class Regex {
  email = /\S+@\S+\.\S+/;

  number = /^[0-9]+$/;
}

export default new Regex();
